import concat from 'lodash/concat'
import get from 'lodash/get'
import set from 'lodash/set'
import toLower from 'lodash/toLower'
import toUpper from 'lodash/toUpper'
import uniq from 'lodash/uniq'

export default function (__GModelData) {
  const excludeProperties = get(__GModelData, 'config.settings.excludeProperties', [])
  // Notes:
  //  - Values listed here get duplicated as upper and lower case
  //  - Values with dashes get duplicated with underscores
  //  - Values with spaces get duplicated with no spaces
  //  - All values are duplicated in upper and lowercase
  const defaultExcludeProperties = [
    '$cqlgeometrywhatshere',
    '$longitude',
    '$latitude',
    '$wkt',
    '$gml',
    '$cqlgeometry',
    '$cqlgeometrysimplified',
    '$cqlgeometrycentroid',
    '$cqlgeometrypointonsurface',
    '$esriGeometry',
    '$esriGeometryType',
    '$area',
    '$length',
    '$type',
    '$x',
    '$y',
    '$z',
    '$id',
    '$sectoken',
    'geometry',
    'id',
    // The field 'pozi_geometry_internal_representation' is a workaround for
    // an OL issue that could not handle feature properties called 'geometry'
    // See OL bug report for this: https://github.com/openlayers/openlayers/issues/14220
    'pozi_geometry_internal_representation',
    'pid',
    '_full_text',
    '_id',
    'marker-url',
    'marker-color',
    'marker-opacity',
    'marker-size',
    'marker-symbol',
    'stroke',
    'stroke-width',
    'stroke-opacity',
    'fill',
    'fill-opacity',
    'style-color',
    'style-color-outline',
    'style-fill-opacity',
    'style-label-align',
    'style-label-baseline',
    'style-label-offset-x',
    'style-label-offset-y',
    'style-label-placement',
    'style-label-max-angle',
    'style-label-overflow',
    'style-label-rotation',
    'style-label-weight',
    'style-label-size',
    'style-size',
    'style-symbol',
    'style-width',
    'style-width-outline',
    'style-opacity',
    'style-fill',
    'style-type',
    'latitude',
    'longitude',
    'x',
    'y',
    'x_coord',
    'y_coord',
    'long',
    'lon',
    'lat',
    'lng',
    'shape_star',
    'shape_stle',
    'shape',
    'ufi',
    'ufi_created',
    'ufi_old',
    'pfi_created',
    'bbox',
    'cartodb_id',
    'created_at',
    'updated_at',
    'defaultstyle',
    'ogc_fid',
    'ogr_fid',
    'layerid',
    'layer_id',
    'layer id'
  ]

  const excludePropertiesMerged = concat(excludeProperties, defaultExcludeProperties)
  const excludePropsParsed = addAlternatesAndRemoveDuplicates(excludePropertiesMerged).sort()
  set(__GModelData, 'config.settings.excludeProperties', excludePropsParsed)
}

function addAlternatesAndRemoveDuplicates (defaultExcludeProperties) {
  if (!defaultExcludeProperties) {
    return []
  }
  let excludeProps = []
  for (const index in defaultExcludeProperties) {
    const prop = defaultExcludeProperties[index]
    if (!prop) {
      continue
    }
    excludeProps.push(prop)

    excludeProps.push(toUpper(prop))
    excludeProps.push(toUpper(prop.replace('_', '-')))
    excludeProps.push(toUpper(prop.replace('-', '_')))
    excludeProps.push(toUpper(prop.replace(' ', '-')))
    excludeProps.push(toUpper(prop.replace(' ', '_')))
    excludeProps.push(toUpper(prop.replace(' ', '')))

    excludeProps.push(toLower(prop))
    excludeProps.push(toLower(prop.replace('_', '-')))
    excludeProps.push(toLower(prop.replace('-', '_')))
    excludeProps.push(toLower(prop.replace(' ', '-')))
    excludeProps.push(toLower(prop.replace(' ', '_')))
    excludeProps.push(toLower(prop.replace(' ', '')))
  }
  excludeProps = uniq(excludeProps)
  const excludePropsSorted = excludeProps.sort()
  return excludePropsSorted
}
